export default __webpack_public_path__ + "static/media/ndtxy.b53db20b.png";